import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class ShareAccepted extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Share Accepted');
    public static getDescription:Function = () => Locale.gettext('A user accepted your share request');
    
}